import React from 'react';
import Header from '../../../components/header';
import ServiceList from './service-list';

import { useLanguage } from '../../../helpers/language-context';

const Services = () => {
  const { translations } = useLanguage();
  return (
    <div className="services-container">
      <Header title={translations.services.title} flip={true} bgImg="/assets/images/header-bg/bg_services_new.jpg" />
      <ServiceList />
    </div>
  );
};

export default Services;
